import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	fillRule: "evenodd",
	clipRule: "evenodd",
	baseProfile: "basic",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			fill: "#bcbcbc",
			points: "23.974,4 6.97,14 6.97,34 23.998,44 40.97,34 40.97,14"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7.97,
			x2: 23.579,
			y1: 33,
			y2: 24.454,
			fill: "none",
			stroke: "#bcbcbc",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 23.972,
			x2: 23.966,
			y1: 5.903,
			y2: 15.864,
			fill: "none",
			stroke: "#bcbcbc",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 39.97,
			x2: 32.97,
			y1: 33,
			y2: 29,
			fill: "none",
			stroke: "#bcbcbc",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "#757575",
			points: "23.974,4 6.97,14 6.97,34 23.97,24"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "#424242",
			points: "23.981,14 40.97,14 40.97,34 23.971,24"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "#616161",
			fillRule: "evenodd",
			points: "40.97,14 23.966,17 23.974,4",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "#616161",
			fillRule: "evenodd",
			points: "6.97,14 23.981,16.881 23.966,24 6.97,34",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "#ededed",
			points: "6.97,14 23.97,24 23.998,44 40.97,14"
		})
	]
});
export default SvgCursor;
